import React from 'react';

export const Footer: React.FC = () => {
    return (
        <footer className="bg-gray-50 pt-20 pb-10 border-t border-gray-200">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
                    <div className="col-span-1 md:col-span-2">
                        <a href="#" className="text-2xl font-bold tracking-tighter text-black">
                            <img src="/site-logo.png" alt="GoLengthening" className="h-20 w-auto" />
                        </a>
                        <p className="mt-6 text-gray-500 max-w-sm">
                            World-class cosmetic limb lengthening in Istanbul. 
                            Safety, transparency, and expert care.
                        </p>
                    </div>
                    
                    <div>
                        <h4 className="font-bold mb-6">Quick Links</h4>
                        <ul className="space-y-4 text-gray-500">
                            <li><a href="#" className="hover:text-[#11BC97]">Process</a></li>
                            <li><a href="#" className="hover:text-[#11BC97]">Pricing</a></li>
                            <li><a href="#" className="hover:text-[#11BC97]">Rehab Facility</a></li>
                            <li><a href="#" className="hover:text-[#11BC97]">FAQ</a></li>
                        </ul>
                    </div>
                    
                    <div>
                        <h4 className="font-bold mb-6">Legal</h4>
                        <ul className="space-y-4 text-gray-500">
                            <li><a href="#" className="hover:text-[#11BC97]">Privacy Policy</a></li>
                            <li><a href="#" className="hover:text-[#11BC97]">Terms of Service</a></li>
                            <li><a href="#" className="hover:text-[#11BC97]">Medical Disclaimer</a></li>
                        </ul>
                    </div>
                </div>
                
                <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
                    <p>&copy; {new Date().getFullYear()} GoLengthening. All rights reserved.</p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        {/* Social Icons placeholders */}
                        <span>Instagram</span>
                        <span>Twitter</span>
                        <span>LinkedIn</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};